<template>
 <div>
    <b-row>
      <!-- <b-col sm="2">
        <div class="text-window">
          <b-row>
            <b-col sm="12">
             <b-input v-model="freeWordFilter" @change="$emit('changeFreeWordFilter', $event)" size="sm" placeholder="会員、会員名、FBA番号、発送"/>
            </b-col>
          </b-row>
        </div>
      </b-col> -->
      <b-col sm="11">
        <div class="text-window">
          <b-row>
            <b-col sm="2">
              <b-input v-model="fbanumberFilter" @change="$emit('changeFbanumberFilter', $event)" size="sm" placeholder="FBA番号"/>
            </b-col>
            <b-col sm="2">
              <b-input v-model="trackingNumberFilter" @change="$emit('changeTrackingNumberFilter', $event)" size="sm" placeholder="追跡番号"/>
            </b-col>
            <b-col sm="2">
              <b-input v-model="memberFilter" @change="$emit('changeMemberFilter', $event)" size="sm" placeholder="会員番号"/>
            </b-col>
            <b-col sm="2">
              <b-input-group size="sm" prepend="Status">
                <b-select size="sm" v-model="statusFilter" @change="$emit('changeFilterStatus', $event)" :options="invoiceStatusTypes"/>
              </b-input-group>
            </b-col>
            <!-- <b-col sm="2">
              <b-input-group size="sm" prepend="年月指定">
                <b-select size="sm" v-model="monthListFilter" @change="$emit('changeMonthListFilter', $event)" :options="monthListTypes"/>
              </b-input-group>
            </b-col> -->
            <b-col class="zoom-back-1" sm="1">
              <date-picker id="startDate" :value="startDate" @change="$emit('updateStartDate', $event)"/>
            </b-col>
            <b-col class="zoom-back-1" sm="1">
              <date-picker id="endDate" :value="endDate" @change="$emit('updateEndDate', $event)"/>
            </b-col>
            <b-col sm="2">
              <b-button size="sm" @click="$emit('clickFilterSearchBtn', $event)" variant="danger">　　　検索　　　</b-button>
            </b-col>
          </b-row>
        </div>
      </b-col>
      <!-- <b-col sm="2">
        <div class="text-window">
          <b-row>
            <b-col sm="9">
             <b-input v-model="trackingNumber" @change="$emit('changeTrackingNumber', $event)" size="sm" placeholder="追跡番号"/>
            </b-col>
            <b-col sm="3">
             <b-button size="sm" @click="$emit('clickOutputLabel', $event)" variant="danger">　Label　</b-button>
            </b-col>
          </b-row>
        </div>
      </b-col> -->
      <b-col sm="1">
        <b-button size="sm" @click="$emit('outputFile')" variant="danger">　ファイル出力　</b-button>
      </b-col>
      <!-- <b-col sm="1">
        <b-button size="sm" @click="$emit('setFolderPath')" variant="success">フォルダ起動パス設定</b-button>
      </b-col> -->
    </b-row>
    <b-row class="component-margin-top-half">
      <b-col sm="12">
        <h6>表示件数: {{ recordCount }} 件（検索合致件数：{{ searchCount }}）／ UPS発送数: {{ upsShippingQuantity }}　UPS総重量: {{upsShippingTotalWeight}}</h6>
      </b-col>
    </b-row>
 </div>
</template>

<script>
import Vue from 'vue';
import BaseComponent from '@/components/BaseComponent';
import DatePicker from '@/components/common/DatePicker';
import InvoiceStatusType from '@/types/InvoiceStatusType';
import MonthListType from '@/types/MonthListType';

export default {
  mixins: [BaseComponent],
  props: {
    freeWordFilter: { default: ''},
    statusFilter: { default: '0' },
    memberFilter: { default: ''},
    fbanumberFilter: { default: ''},
    monthListFilter: { default: '111111'},
    trackingNumberFilter: { default: ''},
    recordCount: { default: '0' },
    searchCount: { default: '0' },
    filterStartDate: { default: '' },
    filterEndDate: { default: '' },
    upsShippingQuantity: { default: 0 },
    upsShippingTotalWeight: { default: 0 }
  },
  data() {
    return {
      invoiceStatusTypes: InvoiceStatusType.values(),
      monthListTypes: MonthListType.valuesForInvoice(),
      registeredDateFilter: null,
      checkRec1month: true,
      StatusFilter: '0'
    };
  },
};
Vue.component('date-picker', DatePicker);
</script>